<!-- 召回通知单列表 -->
<template>
    <div class='page_content'>
        <subComponents ref="showSelectData"></subComponents>
        <el-drawer :close-on-press-escape="true" :visible.sync="dialogVisible" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="50%">
            <categoryManageAction v-if="dialogVisible" ref="categoryManageAction" @drawerCancel="drawerCancel" :actionData="actionData"></categoryManageAction>
        </el-drawer>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" :buttonFlag="false"></v-button>
            <div class="page_content_top_line">
                <v-search :searchList="formList" :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch"></v-search>
            </div>
        </div>
        <div class="page_content_center">
            <el-table @selection-change="handleSelectionChange" row-key="id" :tree-props="{ children: 'children', hasChildren: false }" size="mini" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row>
                <el-table-column type="selection" width="40"></el-table-column>
                <el-table-column prop="id" label="ID">
				</el-table-column>
                <el-table-column align="center" show-overflow-tooltip min-width="200" prop="categoryName" label="分类名称"></el-table-column>
                <el-table-column align="center" show-overflow-tooltip min-width="120" prop="pathCode" label="分类编码"></el-table-column>
            </el-table>
        </div>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" width="800px">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" />
        </el-dialog>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import jsList from "./categoryManage.js";
import categoryManageAction from "@/components/categoryManageAction.vue";
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        categoryManageAction,
    },
    data() {
        //这里存放数据
        return {
            tableHeight: 0,
            getRequestData: {},
            returnData: {
                list: [],
            },
            buttonList: [],
            formList: [],
            multipleSelection: [],
            seId: "",
            dialogTitle: "",
            seWidth: "",
            seTitle: "",
            DialogVisible: false,
            smId: "",
            sField: "",
            parentSearchData: {},
            //-------------
            dialogVisible:false,
            actionData: {},
            classifyList:[],
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        drawerCancel() {
            this.dialogVisible = false
            this.getDataList()
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            if (type == 'salesName') {
                if (this.getRequestData.smId == undefined || this.getRequestData.smId == '') {
                    return this.$message({
                        message: "请先选择单位",
                        type: "error",
                    });
                } else {
                    this.parentSearchData.smId = this.getRequestData.smId
                }
            }
            this.sField = sField;
            this.DialogVisible = true;
            this.seId = sId;
            this.parentSearchData[type] = this.getRequestData[type];
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.getRequestData[item] = val[item]
            })
        },
        // 初始化赋值字段值
        initParamValue(setField) {
            let arr = setField.split(',')
            arr.forEach(item => {
                this.$set(this.getRequestData, item, "")
            })
        },
        // 清空赋值字段
        claerValue(field, pField) {
            if (this.getRequestData[field] == '') {
                this.initParamValue(pField)
            }
        },
        // 检索方案带回数据
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val)
            }
        },        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页    
                var isPenetrate = true
                // 设置缓存 存入点击单号
                this.resetSetItem('penetrateOrderId', orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({ //向窗口发送MessageEvent消息
                    cmd: 'returnFormJson',
                    params: {
                        isPenetrate
                    } //参数
                }, '*');
            }
            this.getPageInfo()
        },
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.getRequestData.end = time;
            }
        },
        
        isShowData(name, value) {
            switch (name) {
                case "ovmApper":
                    var dataInfo = JSON.parse(sessionStorage.getItem("selectUserData"));
                    this.getRequestData.ovmApper = dataInfo.opmId;
                    this.getRequestData.opmName = dataInfo.opmName;
                default:
                    this.getRequestData[name] = value;
            }
        },

        // 获取数据列表
        getPageInfo() {
            var obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
            for (const key in obj) {
                this.$set(this.getRequestData, key, obj[key])
            }
            this.getButtonList();
            this.getDataList();
            this.getDataLis1()
        },
        clear(val) {
            if (val) {
                var arr = val.split(",")
                arr.forEach(item => {
                    this.$set(this.getRequestData, item, "")
                })
            }
        },
        // 动作集合
        actionSet(actionData) {
            console.log(actionData.actionType, 'actionData.actionType');

            switch (actionData.actionType) {
                case 0:
                    this.dialogVisible = true;
                    this.actionData = {
                        cate: 0,
                        formData: "0",
                        oldData: "",
                        classifyList: this.classifyList,
                    };
                    break;
                case 2:
                    this.delDataAction();
                    break;
            }
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1;
            this.getDataList();
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val;
            this.getDataList();
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1;
            this.getRequestData.rows = val;
            this.getDataList();
        },

        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.categoryquery(this.getRequestData);
            if (responseData.status == 200) {
                if (responseData.result.length > 0) {
                    this.returnData.list = this.handleJurisdiction(responseData.result)
                }
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 获取数据列表
        async getDataLis1() {
            let responseData = await this.$http.categoryquery({});
            if (responseData.status == 200) {
                this.classifyList = []
                if (responseData.result.length > 0) {
                    this.classifyList = this.handleJurisdiction(responseData.result)
                    this.classifyList.unshift({
                        id: 0,
                        value: 0,
                        label: '顶级分类',
                        children: null
                    })
                } else {
                    this.returnData.list = []
                    this.classifyList = [{
                        id: 0,
                        value: 0,
                        label: '顶级分类',
                        children: null
                    }]
                }
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 权限处理
        handleJurisdiction(data, id = 0, lev = 0) {
            var son = []
            data.forEach((value, keys) => {
                if (value['parentId'] == id) {
                    value = { ...value }
                    value['id'] = value['id']
                    value['value'] = value['id']
                    value['label'] = value['categoryName']
                    var list = this.handleJurisdiction(data, value['id'], lev + 1);
                    if (list.length >= 1) {
                        value['children'] = this.handleJurisdiction(data, value['id'], lev + 1);
                    }
                    son.push(value)

                }
            })
            return son;
        },
        // 删除数据
        delDataAction() {
            if (this.returnData.list.length <= 0) {
                this.$message({
                    message: '暂无数据',
                    type: 'error'
                });
                return
            } else if (this.multipleSelection.length <= 0) {
                this.$message({
                    message: '请先选中要操作的数据',
                    type: 'error'
                });
                return
            }
            this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    let responseData = await this.$http.categorydelete({ ids: this.multipleSelection.map(item => item.id) });
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        });

                        this.getDataList();
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
                .catch(() => { });
        },

        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
            
        },
},
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.formList = jsList.formList
        this.getPageInfo();
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}
</style>